const Style = {

  base: 'block w mx-auto mb-4 outline-none'

}

export default Style;
